import { render, staticRenderFns } from "./ImportQuestionCSV.vue?vue&type=template&id=74b454f6"
import script from "./ImportQuestionCSV.vue?vue&type=script&lang=js"
export * from "./ImportQuestionCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports